import React from 'react';

import FullCenteredHeading from '../components/Heros/FullCenteredHeading';
import HalfAndHalfHeader from '../components/Heros/HalfAndHalfHeader';
import OverlappingHero from '../components/Heros/OverlappingHero';
import OverUnderHeader from '../components/Heros/OverUnderHeader';
import VideoBkgHero from '../components/Heros/VideoBkgHero';

export const headBuilder = (
  style = '',
  fields = {
    colorTheme: '',
    heading: '',
    headingFontColor: '',
    headingTheme: '',
    lede: '',
    videoUrl: '',
    ctas: [],
    heroImage: {},
    backgroundImage: {},
    headingSize: '',
    headingSuper: '',
    superHeadingIcon: null,
    backgroundColor: '',
  }
) => {
  const headingStyle = style.toLowerCase();
  let heading;
  switch (headingStyle) {
    case 'half and half':
    case 'half and half slim':
    case 'half and half with vertical bleed': {
      heading = (
        <HalfAndHalfHeader
          fields={fields}
          slim={headingStyle === 'half and half slim'}
          verticalBleed={style === 'Half and half with vertical bleed'}
        />
      );
      break;
    }
    case 'movie background': {
      heading = <VideoBkgHero fields={fields} />;
      break;
    }
    case 'centered bleed': {
      heading = (
        <FullCenteredHeading
          superText={fields.headingSuper}
          heading={fields.heading}
          copy={fields.lede}
          ctas={fields.ctas}
          videoUrl={fields.videoUrl}
          backgroundImage={fields.backgroundImage}
          headingSize={fields.headingSize}
        />
      );
      break;
    }
    case 'centered full background': {
      heading = (
        <FullCenteredHeading
          heading={fields.heading}
          copy={fields.lede}
          image={fields.heroImage}
          backgroundImage={fields.backgroundImage}
          superText={fields.headingSuper}
          ctas={fields.ctas}
          headingSize={fields.headingSize}
        />
      );
      break;
    }
    case 'over under': {
      heading = (
        <OverUnderHeader heading={fields.heading} image={fields.heroImage} lede={fields.lede} ctas={fields.ctas} />
      );
      break;
    }
    case 'overlapping bleed':
    case 'overlapping':
    case 'overlapping centered':
    case 'half and half blobs': {
      heading = (
        <OverlappingHero
          colorTheme={fields.colorTheme}
          backgroundColor={fields.backgroundColor}
          backgroundImage={fields.backgroundImage}
          copy={fields.lede}
          hero={fields.heroImage}
          headingSuper={fields.headingSuper}
          heading={fields.heading}
          center={style === 'Overlapping Centered'}
          videoUrl={fields.videoUrl}
          fullBleed={style === 'Overlapping Bleed' || fields.backgroundImage}
          ctas={fields.ctas}
          blobs={style === 'Half and half blobs'}
        />
      );
      break;
    }
    case 'anchored blobs': {
      heading = (
        <OverlappingHero
          colorTheme={fields.colorTheme}
          backgroundColor={fields.backgroundColor}
          backgroundImage={fields.backgroundImage}
          copy={fields.lede}
          hero={fields.heroImage}
          headingSuper={fields.headingSuper}
          headingSuperIcon={fields.headingSuperIcon}
          heading={fields.heading}
          center={false}
          fullBleed={true}
          ctas={fields.ctas}
          blobs={true}
          anchored={true}
        />
      );
      break;
    }
    default: {
      return null;
    }
  }
  return heading;
};
